<template>
  <div class="h-full flex flex-col md:flex-row min-h-0">
    <!-- variety picker -->
    <aside class="w-full h-40 border-b md:w-60 md:h-auto md:border-b-0 md:border-r shrink-0 border-line overflow-y-auto py-3">
      <p class="px-4 text-[0.65rem] uppercase tracking-[0.18em] text-ink-faint mb-2">Documented parentage</p>
      <button v-for="g in withParents" :key="g.slug" @click="selectGrape(g.slug)"
        class="w-full text-left px-4 py-1.5 text-sm flex items-center gap-2 hover:bg-wine/10"
        :class="g.slug === store.selectedSlug ? 'text-ink bg-wine/15' : 'text-ink-dim'">
        <span class="w-2 h-2 rounded-full shrink-0" :style="{ background: berryColor(g.color) }" />
        {{ g.name }}
      </button>
    </aside>

    <!-- pedigree -->
    <div class="flex-1 min-w-0 overflow-auto p-5 md:p-10">
      <template v-if="focus">
        <h2 class="font-display text-3xl mb-1">{{ focus.name }}</h2>
        <p class="text-sm text-ink-dim mb-8 max-w-xl">Family tree — DNA-established parentage only. Click any name to walk the vine.</p>

        <div class="flex flex-col md:flex-row items-start gap-8 md:gap-16">
          <!-- ancestors -->
          <div>
            <p class="text-[0.65rem] uppercase tracking-[0.18em] text-ink-faint mb-3">Ancestry</p>
            <PedigreeNode :slug="focus.slug" :depth="0" />
          </div>

          <!-- descendants -->
          <div v-if="kids.length">
            <p class="text-[0.65rem] uppercase tracking-[0.18em] text-ink-faint mb-3">Offspring</p>
            <div class="flex flex-col gap-2">
              <button v-for="k in kids" :key="k" @click="selectGrape(k)"
                class="chip hover:bg-wine/15 cursor-pointer text-sm !py-1.5 !px-3">
                {{ bySlug.get(k)?.name }}
              </button>
            </div>
          </div>
        </div>

        <p v-if="!focus.parent1_slug && !focus.parent2_slug" class="mt-6 text-ink-dim italic font-display">
          Parentage unknown or still disputed — the vine keeps some secrets.
        </p>
      </template>
      <div v-else class="h-full grid place-items-center text-ink-dim font-display italic text-xl">
        pick a grape to trace its bloodline
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { store, bySlug, fullGrapes, selectGrape, childrenOf, selectedGrape, berryColor } from "../store"
import PedigreeNode from "./PedigreeNode.vue"

const withParents = computed(() =>
  fullGrapes.value.filter(g => g.parent1_slug || g.parent2_slug).sort((a, b) => a.name.localeCompare(b.name))
)

const focus = computed(() => selectedGrape.value && !selectedGrape.value.ancestor_only
  ? selectedGrape.value
  : selectedGrape.value)

const kids = computed(() => focus.value ? (childrenOf.value.get(focus.value.slug) || []) : [])
</script>
